import { Stack, useTheme } from "@mui/material";
import { IdCard, Mail, Mailbox, MapPin, Phone } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { ProfileAccountRow } from "web_myplann/Profile/Components/ProfileAccountRow";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

const R = Resources.Profile;

type Props = {
	email: string;
	phone: string;
	permanentAddress: string;
	contactAddress: string;
};

export const ProfileDetailsList: FC<Props> = ({
	email,
	phone,
	permanentAddress,
	contactAddress,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	return (
		<Stack borderTop={theme.colors.border.solid(theme.palette.grey[100])}>
			{!!email && (
				<ProfileAccountRow
					icon={Mail}
					label={t(R.Fields.email)}
					value={email}
				/>
			)}
			{!!phone && (
				<ProfileAccountRow
					icon={Phone}
					label={t(R.Fields.phone)}
					value={phone}
				/>
			)}
			<ListRow
				title={t(Resources.PersonalDataAndAccounts.PersonalData.title)}
				icon={
					<IdCard size={theme.iconSize.sm} color={theme.palette.grey[500]} />
				}
				iconBg={theme.palette.grey[100]}
				onClick={() =>
					navigate(AppRouting.MyPlann.Profile.PersonalDataAndAccounts.path())
				}
				showChevron
			/>
			{!!permanentAddress && (
				<ProfileAccountRow
					icon={MapPin}
					label={t(Resources.Addresses.PermanentAddress.title)}
					value={permanentAddress}
					wrapValue
					isLast={!contactAddress}
				/>
			)}
			{!!contactAddress && (
				<ProfileAccountRow
					icon={Mailbox}
					label={t(Resources.Addresses.ContactAddress.title)}
					value={contactAddress}
					wrapValue
					isLast
				/>
			)}
		</Stack>
	);
};
